export const removeHtmlTags = (
  htmlString: string | undefined
): string | undefined => {
  if (!htmlString) return undefined;
  return htmlString
    .replace(/(<([^>]+)>)/gi, '') // delete html tag
    .replace(/(\r\n|\n|\r)/gm, ' ') // replace line breaks by a space
    .replace(/\s\s/, ' '); // remove double spaces (can be generated by the previous method, if there was a useless trailing space before the line break)
};
